import { render, staticRenderFns } from "./AddMetadata.html?vue&type=template&id=4b925434&scoped=true&"
import script from "./AddMetadata.vue?vue&type=script&lang=js&"
export * from "./AddMetadata.vue?vue&type=script&lang=js&"
import style0 from "./AddMetadata.vue?vue&type=style&index=0&id=4b925434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b925434",
  null
  
)

export default component.exports